<script>
import { Doughnut } from 'vue-chartjs'
import {hexToRgba} from "@coreui/coreui-pro/dist/js/coreui-utilities";
export default {
  extends: Doughnut,
    props: {
        cycling:0,
        treadmill:0,
        elliptical:0,
    },
  mounted () {
    this.renderChart({
      labels: ['Indoor Cycling', 'Treadmill', 'Elliptical'],
      datasets: [
        {
          borderWidth:1,
          borderColor:[
            '#20a8d8',
            '#4dbd74'
          ],
          backgroundColor: [
            hexToRgba('#20a8d8',30),
            hexToRgba('#4dbd74',30)
          ],
          data: [this.cycling, this.treadmill, this.elliptical]
        }
      ]
    }, {
        legend: {
            
            labels: {
                fontColor: "#fff",
                fontSize: 12
            }
        },
      responsive: true, maintainAspectRatio: true, })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/Doughnut.vue